// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__2kX5y","inMobile":"styles_inMobile__3CW-m"};